import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "app/services/global.service";
import { PageService } from "app/services/page-service";
import { environment } from "environments/environment";

@Component({
  selector: "app-add-wallet",
  templateUrl: "./add-wallet.component.html",
  styles: [],
})
export class AddWalletComponent implements OnInit {
  @Input() data: any;
  loader = false;
  adminDetails = JSON.parse(localStorage.getItem("userDetails"));
  adminMailID = this.adminDetails["record"]["emailID"];
  password = "";
  amount = "";
  authLoader = false;
  authSuccess = false;
  customerID = "";
  errorMsg = "";
  currency = environment.CURRENCY;

  constructor(
    public dialogRef: NgbActiveModal,
    public global: GlobalService,
    public service: PageService
  ) {}

  ngOnInit(): void {
    this.customerID = this.data["customerID"];
    this.service.getplatformConfig().then((data) => {
      const platformData = data['Data'];
      this.currency = platformData && platformData['currency'] ? platformData['currency'] : environment.CURRENCY;
    });
  }

  close() {
    this.dialogRef.close({ success: false });
  }

  confirmPassword() {
    this.authLoader = true;
    const authData = {
      login: {
        emailID: this.adminMailID,
        password: this.password,
      },
    };
    this.service
      .postMethod("aggregator/login", authData)
      .then((response) => {
        this.authLoader = false;
        this.authSuccess = response["Success"];
      })
      .catch((err) => {
        console.log(err);
        this.authLoader = false;
        this.authSuccess = err["error"]["Success"];
        this.global.failureErrorModal(err["error"]["Error"]);
      });
  }

  addAmount() {
    const regex = /^[0-9]*(\.[0-9]{0,2})?$/;
    if (!regex.test(this.amount)) {
      this.errorMsg = "* Please Enter a Valid Amount";
      setTimeout(() => {
        this.errorMsg = "";
      }, 2000);
      return;
    }
    if (parseFloat(this.amount) <= 1) {
      this.errorMsg = "* Please Enter an amount greater than 1";
      setTimeout(() => {
        this.errorMsg = "";
      }, 2000);
      return;
    }
    this.loader = true;
    const walletData = {
      amount: this.amount,
      userID: this.customerID,
    };
    this.service
      .postMethod("customer/addCustomerWallet", walletData)
      .then((response) => {
        this.loader = false;
        this.dialogRef.close({ success: true });
      })
      .catch((err) => {
        this.loader = false;
        this.global.failureErrorModal(err);
      });
  }
}
